<template lang="pug">
ReportBaseSelectFilter.work-break-policy-filter(
  label="Policies"
  placeholder="All policies"
  :options="options"
  query-property="work_break_policies"
)
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportWorkBreakPolicyFilter',
  computed: {
    options() {
      const archivedPolicies = [];
      const result = [];

      // FIXME: This could be a getter instead (see ReportWorkBreakStatusFilter)
      if (this.allWorkBreakPolicies) {
        this.allWorkBreakPolicies.forEach((policy) => {
          (policy.archived ? archivedPolicies : result).push({
            id: policy.id,
            text: policy.name,
          });
        });

        if (archivedPolicies.length > 0) {
          result.push({
            text: 'Archived',
            children: archivedPolicies,
          });
        }
      }

      return result;
    },
    ...mapGetters(['allWorkBreakPolicies']),
  },
};
</script>
